module.exports = __webpack_public_path__ + "static/img/signature.5f0ebf55.svg";